import React from 'react';
import { Link } from 'react-router-dom';

export function Footer(): JSX.Element {
  return (
    <footer className='border-t border-border py-12'>
      <div className='mx-auto grid max-w-6xl grid-cols-1 items-center gap-6 px-6 md:grid-cols-[1fr_auto_1fr]'>
        <div className='flex items-center gap-2 md:justify-self-start justify-self-center'>
          <div className='flex h-7 w-7 items-center justify-center rounded-lg bg-teal'>
            <span className='text-xs font-bold text-navy'>S</span>
          </div>
          <span
            className='text-sm font-semibold tracking-tight text-foreground'
            style={{ fontFamily: 'var(--font-heading)' }}
          >
            Strada
          </span>
        </div>

        <nav className='flex items-center gap-8 md:justify-self-center justify-self-center' aria-label='Footer navigation'>
          <a href='#platform' className='text-sm text-muted-foreground transition-colors hover:text-foreground'>
            Platform
          </a>
          <Link to='/terms-and-conditions' className='text-sm text-muted-foreground transition-colors hover:text-foreground'>
            Terms
          </Link>
          <Link to='/contact-us' className='text-sm text-muted-foreground transition-colors hover:text-foreground'>
            Contact
          </Link>
          <Link to='/privacy-policy' className='text-sm text-muted-foreground transition-colors hover:text-foreground'>
            Privacy
          </Link>
        </nav>

        <p className='text-xs text-muted-foreground/60 md:justify-self-end justify-self-center'>
          &copy;
          {' '}
          {new Date().getFullYear()}
          {' '}
          Strada. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
